<section class="interactive-pricing-section ptb-100">
  <div class="container">
    <!-- Debug: Test icons visibility -->
    <div style="display: none;">
      <i class="bx bxl-linux"></i>
      <i class="bx bxl-windows"></i>
      <i class="bx bx-data"></i>
      <i class="bx bx-server"></i>
      <i class="bx bx-globe"></i>
      <i class="fab fa-windows"></i>
      <i class="fas fa-database"></i>
    </div>
    
    <div class="section-title text-center mb-5">
      <span class="section-badge">Interactive Pricing Calculator</span>
      <h2>Cloud Infrastructure <span class="text-gradient">Pricing</span></h2>
      <p>Select your service category, plan, and billing cycle to see real-time pricing</p>
    </div>

    <div class="row">
      <!-- Category Selection -->
      <div class="col-lg-12 mb-4">
        <div class="category-selector">
          <h4 class="selector-title">Select Operating System</h4>
          <div class="category-options">
            <div class="row">
              <div class="col-md-4 col-sm-6 mb-3">
                <div class="category-card" 
                     [class.active]="selectedCategory === 'linux'"
                     (click)="onCategoryChange('linux')"
                     role="button"
                     tabindex="0"
                     (keydown.enter)="onCategoryChange('linux')"
                     (keydown.space)="onCategoryChange('linux')"
                     aria-label="Select Linux operating system"
                     title="Linux - Open-source flexibility and performance">
                  <div class="category-icon linux-icon" aria-hidden="true">
                    <i class="fab fa-linux"></i>
                  </div>
                  <!-- Removed text content to show only icon -->
                </div>
              </div>
              <div class="col-md-4 col-sm-6 mb-3">
                <div class="category-card" 
                     [class.active]="selectedCategory === 'windows'"
                     (click)="onCategoryChange('windows')"
                     role="button"
                     tabindex="0"
                     (keydown.enter)="onCategoryChange('windows')"
                     (keydown.space)="onCategoryChange('windows')"
                     aria-label="Select Windows operating system"
                     title="Windows - Full Windows Server compatibility">
                  <div class="category-icon windows-icon" aria-hidden="true">
                    <i class="fab fa-windows"></i>
                  </div>
                  <!-- Removed text content to show only icon -->
                </div>
              </div>
              <div class="col-md-4 col-sm-6 mb-3">
                <div class="category-card" 
                     [class.active]="selectedCategory === 'windows-mssql'"
                     (click)="onCategoryChange('windows-mssql')"
                     role="button"
                     tabindex="0"
                     (keydown.enter)="onCategoryChange('windows-mssql')"
                     (keydown.space)="onCategoryChange('windows-mssql')"
                     aria-label="Select Windows with MSSQL"
                     title="Windows + MSSQL - Pre-configured with SQL Server">
                  <div class="category-icon mssql-icon" aria-hidden="true">
                    <div class="icon-combo">
                      <i class="fab fa-windows combo-icon windows-combo"></i>
                      <i class="fas fa-database combo-icon database-combo"></i>
                    </div>
                  </div>
                  <!-- Removed text content to show only icon -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Edition Selection (for Windows MSSQL) -->
      <div class="col-lg-12 mb-4" *ngIf="selectedCategory === 'windows-mssql'">
        <div class="edition-selector">
          <h4 class="selector-title">Select SQL Server Edition</h4>
          <div class="edition-options">
            <div class="row">
              <div class="col-md-6 mb-3">
                <div class="edition-card" 
                     [class.active]="selectedEdition === 'standard'"
                     (click)="onEditionChange('standard')"
                     role="button"
                     tabindex="0"
                     (keydown.enter)="onEditionChange('standard')"
                     (keydown.space)="onEditionChange('standard')"
                     aria-label="Select Standard Edition SQL Server"
                     title="Standard Edition - Ideal for small to medium businesses with advanced features">
                  <div class="edition-icon standard-icon" aria-hidden="true">
                    <i class="fas fa-server" aria-hidden="true"></i>
                  </div>
                  <!-- Removed text content to show only icon -->
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="edition-card" 
                     [class.active]="selectedEdition === 'web'"
                     (click)="onEditionChange('web')"
                     role="button"
                     tabindex="0"
                     (keydown.enter)="onEditionChange('web')"
                     (keydown.space)="onEditionChange('web')"
                     aria-label="Select Web Edition SQL Server"
                     title="Web Edition - Cost-effective solution for web applications">
                  <div class="edition-icon web-icon" aria-hidden="true">
                    <i class="fas fa-globe" aria-hidden="true"></i>
                  </div>
                  <!-- Removed text content to show only icon -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="row">
          <!-- Plan Selection -->
          <div class="col-lg-8">
            <div class="plan-selector">
              <h4 class="selector-title">
                <span *ngIf="selectedCategory === 'linux'">Linux Plans</span>
                <span *ngIf="selectedCategory === 'windows'">Windows Plans</span>
                <span *ngIf="selectedCategory === 'windows-mssql' && selectedEdition === 'standard'">Windows + MSSQL Standard Edition Plans</span>
                <span *ngIf="selectedCategory === 'windows-mssql' && selectedEdition === 'web'">Windows + MSSQL Web Edition Plans</span>
              </h4>
              <div class="plan-description mb-3">
                <p *ngIf="selectedCategory === 'linux'">{{ selectedCategoryData?.description }}</p>
                <p *ngIf="selectedCategory === 'windows'">{{ selectedCategoryData?.description }}</p>
                <p *ngIf="selectedCategory === 'windows-mssql' && selectedEdition === 'standard'">{{ selectedEditionData?.description }}</p>
                <p *ngIf="selectedCategory === 'windows-mssql' && selectedEdition === 'web'">{{ selectedEditionData?.description }}</p>
              </div>
              <div class="plan-options">
                <div class="row">
                  <div class="col-md-6 mb-4" *ngFor="let plan of selectedPlans">
                    <div class="plan-card" 
                         [class.active]="selectedPlan === plan.id"
                         [class.popular]="plan.popular"
                         (click)="onPlanChange(plan.id)">
                      <div class="plan-header">
                        <h5>{{ plan.name }}</h5>
                        <p class="plan-description">{{ plan.description }}</p>
                        <div class="popular-badge" *ngIf="plan.popular">Most Popular</div>
                      </div>
                      <div class="plan-specs">
                        <div class="spec-item">
                          <i class="fas fa-microchip"></i>
                          <span>{{ plan.vcpu }} vCPU</span>
                        </div>
                        <div class="spec-item">
                          <i class="fas fa-memory"></i>
                          <span>{{ plan.ram }} RAM</span>
                        </div>
                        <div class="spec-item">
                          <i class="fas fa-hdd"></i>
                          <span>{{ plan.storage }}</span>
                        </div>
                      </div>
                      <div class="plan-pricing">
                        <div class="contact-sales-badge">
                          <i class="fas fa-phone"></i>
                          <span>Contact Sales</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Pricing Summary -->
          <div class="col-lg-4">
            <div class="pricing-summary">
              <h4 class="selector-title">Pricing Summary</h4>
              <div class="summary-card">
                <div class="selected-service">
                  <h5 *ngIf="selectedCategory === 'linux'">{{ selectedCategoryData?.name }}</h5>
                  <h5 *ngIf="selectedCategory === 'windows'">{{ selectedCategoryData?.name }}</h5>
                  <h5 *ngIf="selectedCategory === 'windows-mssql'">{{ selectedEditionData?.name }}</h5>
                  <p>{{ selectedPlanData?.name }} - {{ selectedPlanData?.description }}</p>
                </div>

                <div class="selected-specs">
                  <div class="spec-row">
                    <span>vCPU:</span>
                    <strong>{{ selectedPlanData?.vcpu }}</strong>
                  </div>
                  <div class="spec-row">
                    <span>RAM:</span>
                    <strong>{{ selectedPlanData?.ram }}</strong>
                  </div>
                  <div class="spec-row">
                    <span>Storage:</span>
                    <strong>{{ selectedPlanData?.storage }}</strong>
                  </div>
                </div>

                <div class="billing-selector">
                  <h6>Billing Cycle</h6>
                  <div class="billing-options">
                    <button class="billing-option" 
                            [class.active]="billingCycle === 'hourly'"
                            (click)="onBillingCycleChange('hourly')">
                      Hourly
                    </button>
                    <button class="billing-option" 
                            [class.active]="billingCycle === 'monthly'"
                            (click)="onBillingCycleChange('monthly')">
                      Monthly
                    </button>
                    <button class="billing-option" 
                            [class.active]="billingCycle === 'yearly'"
                            (click)="onBillingCycleChange('yearly')"
                            *ngIf="selectedPlanData?.yearlyRate">
                      Yearly
                    </button>
                  </div>
                </div>

                <div class="total-price">
                  <div class="price-label">Pricing</div>
                  <div class="contact-sales-info">
                    <i class="fas fa-phone-alt"></i>
                    <span>Contact Sales for Pricing</span>
                  </div>
                </div>

                <div class="action-buttons">
                  <a routerLink="/sign-up" class="btn btn-primary btn-lg w-100 mb-3">
                    <i class="fas fa-server"></i> Deploy Now
                  </a>
                  <a routerLink="/contact" class="btn btn-outline-primary btn-lg w-100">
                    <i class="fas fa-phone"></i> Contact Sales
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>